import React, { useState } from "react";
import { Images } from "lucide-react";

import { Button } from "components/ui/button";

import {
  type BannerAspect,
  type CampaignType,
  type IBannerGalleryItem,
} from "@/@types/gamification";

import { BANNER_GALLERY_COPY } from "../constants/messages";
import { BannerGalleryDialog } from "./banner-gallery-dialog";

interface BannerGalleryPickerProps {
  aspect: BannerAspect;
  slotLabel: string;
  campaignType?: CampaignType;
  selectedLabel: string | null;
  onSelect: (item: IBannerGalleryItem) => void;
}

export const BannerGalleryPicker: React.FC<BannerGalleryPickerProps> = ({
  aspect,
  slotLabel,
  campaignType,
  selectedLabel,
  onSelect,
}) => {
  const [open, setOpen] = useState<boolean>(false);

  const handleSelect = (item: IBannerGalleryItem): void => {
    onSelect(item);
    setOpen(false);
  };

  return (
    <div className="flex flex-col gap-2">
      {selectedLabel && (
        <p className="text-sm font-medium text-primary">
          {BANNER_GALLERY_COPY.selected(selectedLabel)}
        </p>
      )}
      <Button
        type="button"
        variant="outline"
        className="min-h-11 w-fit focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
        aria-label={BANNER_GALLERY_COPY.openFor(slotLabel)}
        onClick={() => setOpen(true)}
      >
        <Images className="mr-2 h-4 w-4" aria-hidden="true" />
        {BANNER_GALLERY_COPY.open}
      </Button>
      <BannerGalleryDialog
        open={open}
        onOpenChange={setOpen}
        aspect={aspect}
        campaignType={campaignType}
        onSelect={handleSelect}
      />
    </div>
  );
};
